export function findAncestorWithComponent(entity, componentName) {
  const interactableId = entity.closest("[data-interactable-id]")?.dataset.interactableId;
  const interactableEl = interactableId ? document.getElementById(interactableId) : null;

  let searchEl = interactableEl || entity;
  while (searchEl && !(searchEl.components && searchEl.components[componentName])) {
    searchEl = searchEl.parentNode;
  }
  return searchEl;
}

export function findComponentsInNearestAncestor(entity, componentName) {
  const components = [];
  while (entity) {
    if (entity.components) {
      for (const c in entity.components) {
        if (entity.components[c].name === componentName) {
          components.push(entity.components[c]);
        }
      }
    }
    if (components.length) {
      return components;
    }
    entity = entity.parentNode;
  }
  return components;
}

export function getNetworkedEntity(el) {
  const interactableId = el.closest("[data-interactable-id]")?.dataset.interactableId;
  const interactableEl = interactableId ? document.getElementById(interactableId) : null;
  const entity = interactableEl || el;

  return NAF.utils.getNetworkedEntity(entity);
}

export function getInteractableEntity(el) {
  const interactableId = el.closest("[data-interactable-id]")?.dataset.interactableId;
  if (!interactableId) return null;
  const interactableEl = document.getElementById(interactableId);
  const entity = interactableEl;

  return entity;
}